<div class="panel"
 [ngClass]="{'shadow': openMenu && shadow}"
 (clickOutside)="openMenu = false"
 [clickOutsideEnabled]="openMenu"

 >
  <div class="panel-header" (click)="openMenu = !openMenu">
    <span>{{ currentValue }}</span>
    <i
      class="material-icons"
      [ngClass]="{ open: openMenu }"
      >keyboard_arrow_down</i
    >
  </div>

  <div
    #panelItems
    *ngIf="items.length"
    class="hidden-panel"
    [ngStyle]="{ height: openMenu ? heightItem + 'px' : '0px' }"
  >
    <div class="main-divider"></div>
    <div 
    *ngFor="let item of items" 
    (click)="setItem(item)" 
    [matTooltip]="item"
    [matTooltipDisabled]="item.length <= showtoolTipFrom"
    [matTooltipPosition]="'right'"
    class="item"
    >
      <span class="item-text" [ngClass]="{ selected: currentValue === item }">{{
        item
      }}</span>
    </div>
  </div>
</div>
